var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customCheckbox checkbox" }, [
    _c(
      "label",
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.state,
              expression: "state",
            },
          ],
          attrs: { type: "checkbox", disabled: _vm.disabled },
          domProps: {
            checked: Array.isArray(_vm.state)
              ? _vm._i(_vm.state, null) > -1
              : _vm.state,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.state,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.state = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.state = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.state = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }